import apiFinanzas from './apiBase'

/**
 * Servicio para Movimientos Financieros (Ingresos y Egresos)
 */
export const movimientosServicio = {
  /**
   * Listar movimientos con filtros opcionales
   */
  async listar(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/movimientos', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al listar movimientos:', error)
      throw error
    }
  },

  /**
   * Obtener un movimiento por ID
   */
  async obtener(id) {
    try {
      const response = await apiFinanzas.get(`/finanzas/movimientos/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al obtener movimiento:', error)
      throw error
    }
  },

  /**
   * Crear nuevo movimiento (ingreso/gasto/transferencia)
   */
  async crear(datos) {
    try {
      const response = await apiFinanzas.post('/finanzas/movimientos', datos)
      return response.data || response
    } catch (error) {
      console.error('Error al crear movimiento:', error)
      throw error
    }
  },

  /**
   * Actualizar movimiento
   */
  async actualizar(id, datos) {
    try {
      const response = await apiFinanzas.put(`/finanzas/movimientos/${id}`, datos)
      return response.data || response
    } catch (error) {
      console.error('Error al actualizar movimiento:', error)
      throw error
    }
  },

  /**
   * Eliminar movimiento
   */
  async eliminar(id) {
    try {
      const response = await apiFinanzas.delete(`/finanzas/movimientos/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al eliminar movimiento:', error)
      throw error
    }
  },

  /**
   * Obtener resumen de ingresos
   */
  async resumenIngresos(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/movimientos/resumen/ingresos', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al obtener resumen de ingresos:', error)
      throw error
    }
  },

  /**
   * Obtener resumen de egresos
   */
  async resumenEgresos(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/movimientos/resumen/egresos', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al obtener resumen de egresos:', error)
      throw error
    }
  }
}

export default movimientosServicio
